import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { C, R } from "@/brand/tokens";

const VARIANTS = {
  primary: {
    base: { background: C.surfacePrimary, color: C.textOnDark, border: `1px solid ${C.surfacePrimary}` },
    hover: { background: C.bgDark, borderColor: C.bgDark },
  },
  light: {
    base: { background: C.textOnDark, color: C.surfacePrimary, border: `1px solid ${C.textOnDark}` },
    hover: { background: "#FFFFFF", borderColor: "#FFFFFF" },
  },
  outline: {
    base: { background: "transparent", color: C.surfacePrimary, border: `1px solid ${C.surfacePrimary}` },
    hover: { background: C.surfacePrimary, color: C.textOnDark },
  },
  outlineLight: {
    base: { background: "transparent", color: C.textOnDark, border: `1px solid ${C.whiteOnDarkSoft}` },
    hover: { borderColor: C.textOnDark, background: "rgba(244,241,234,0.08)" },
  },
};

/**
 * Cta6 — the button system. Deep Mineral Blue is the primary CTA on light
 * surfaces; Witness White fill is the primary on dark surfaces.
 * Renders <Link>, <a>, or <button> depending on props.
 */
export function Cta6({
  to,
  href,
  type = "button",
  variant = "primary",
  children,
  testId,
  className = "",
  arrow = true,
  external,
  onClick,
  disabled,
  wrap = false,
}) {
  const v = VARIANTS[variant] || VARIANTS.primary;
  const props = {
    "data-testid": testId,
    className: `group inline-flex items-center justify-center gap-3 px-6 py-3.5 font-inter text-[11.5px] uppercase font-semibold ${wrap ? "text-center" : "whitespace-nowrap"} transition-colors ${className}`,
    style: { ...v.base, borderRadius: R.button, letterSpacing: "0.18em" },
    onMouseEnter: (e) => Object.assign(e.currentTarget.style, v.hover),
    onMouseLeave: (e) => Object.assign(e.currentTarget.style, v.base),
    onClick,
  };
  const inner = (
    <>
      {children}
      {arrow && (
        <ArrowRight size={12} weight="bold" className="transition-transform group-hover:translate-x-1" />
      )}
    </>
  );
  if (to) return <Link to={to} {...props}>{inner}</Link>;
  if (href) {
    return (
      <a href={href} target={external ? "_blank" : undefined} rel={external ? "noreferrer" : undefined} {...props}>
        {inner}
      </a>
    );
  }
  return (
    <button type={type} disabled={disabled} {...props}>
      {inner}
    </button>
  );
}
